const { data } = require('jquery');
require('./bootstrap');

$(function(){
    var swiper = new Swiper(".mySwiper", {
        centeredSlides: true,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        on: {
            slideChangeTransitionStart: function () {
              $('.carousel-caption').hide(0);
              $('.carousel-caption').removeClass('aos-init').removeClass('aos-animate');
            },
            slideChangeTransitionEnd: function () {
              $('.carousel-caption').show(0);
              AOS.init();
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
    });

    //swiper.autoplay.stop();

    AOS.init()

    gfn.globalEvent()
})
